<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center"
            >
              <img
                src="@/assets/images/pages/reset-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div
              class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg"
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Redefina sua senha</h4>
                  <p>Por Favor entre com sua nova senha.</p>
                </div>
                <vs-input
                  type="password"
                  name="newPassword"
                  label-placeholder="Senha"
                  v-model="newPassword"
                  class="w-full mb-6"
                  v-validate="'required'"
                />
                <vs-input
                  type="password"
                  name="confirmNewPassword"
                  label-placeholder="Confirme sua Senha"
                  v-model="confirmNewPassword"
                  class="w-full mb-8"
                  v-validate="'required'"
                />

                <div
                  class="flex flex-wrap justify-between flex-col-reverse sm:flex-row"
                >
                  <vs-button
                    type="border"
                    to="/"
                    class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                    >Voltar</vs-button
                  >
                  <vs-button
                    class="w-full sm:w-auto"
                    @click="updateUser()"
                    :disabled="!isFormValid"
                    >Redefinir</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { baseApiUrl } from "@/global";
import axios from "axios";
export default {

  data() {
    return {
      email: "",
      newPassword: "",
      confirmNewPassword: "",
      token: "",
    };
  },
  computed: {
    isFormValid() {
      return (
        !this.errors.any() &&
        this.newPassword &&
        this.confirmNewPassword &&
        this.newPassword === this.confirmNewPassword
      );
    },
  },
  methods: {
    async updateUser() {
      let result = this.$validator.validateAll();
      if (result) {
        try {
          this.user = {
            token: this.token,
            password1: this.newPassword,
            password2: this.confirmNewPassword,
          };
          this.$vs.loading();
          await axios.post(
            `${baseApiUrl}/user/resetPassword`,
            this.user
          );
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Salvo",
            text: "com Sucesso",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
          this.newPassword = "";
          this.confirmNewPassword = "";
          this.$router.push(`/`).catch(() => {});
        } catch (error) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: "Não foi possivel salvar " + error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      } else {
        return;
      }
    },
  },
  created() {
    if(this.$route.query.token){
      this.token = this.$route.query.token
    }else{
      this.$router.push(`/`).catch(() => {});
    }
  
  },
};
</script>
